export default __webpack_public_path__ + "static/media/logo.039b4472.svg";